module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAPCAYAAAAYjcSfAAABKUlEQVQ4T72UMUoDQRSG/38TUwhW2rgqEdQT6BX0AHaZQHbBLnU8gpXW1tnAzjaeQM/gASQKijpptFEIuG72SSyMJGFH2Wymfvzf+96bGZrIP4FIC0AFxZ8Y5BmN9hIApeJ5P4SYvcjrimB7flC5oQmPqnCSQ0ml8PGS+EQZF5yf4Yg0FfoUNJadMjfzNpQmcr/udV7Hcyagj6G/U6JcA1jKCwXwNhDubdTb3d9ZE9DnyFcUCWcA/I4Qsr5Wa+tM6IxN3wfCXavpsCOjayuQSjW3LeMHV0Uv1p3mBv0hwPpkhjeZC46CpIvWPDp94iOaZpe50/Fgo71LAPtW4KjgylXBQVa91dRo7xbA1j+gd64KMr9VK7SnG00RnoKwj1fQJ+V4VXXOs5r8AtSIXzSypCfRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/Product/filter-category.png
// module id = 629
// module chunks = 0